module.exports = __webpack_public_path__ + "img/XK.34c950cb.png";